import React from 'react';

import BillPaymentsTable from '../../../../BillPaymentsTable';
import Pagination from '../../../../Pagination';

import VendorService from '../../../../../services/VendorService';
import usePagination from '../../../../../hooks/usePagination';

export default function BillPayments({ vendorId }) {
  const { currentPage, switchToPage, pageTotal, isFetching, data } =
    usePagination({
      queryKey: ['billPayments', vendorId],
      queryFn: VendorService.getVendorBillPayments,
      queryFnArgs: { vendorId },
    });

  return (
    <div>
      <BillPaymentsTable isFetching={isFetching} billPayments={data?.items} />
      <Pagination
        pageTotal={pageTotal}
        switchToPage={switchToPage}
        currentPage={currentPage}
      />
    </div>
  );
}
